import { useState } from 'react'
import { describeRule } from '@/components/RepeatPicker'
import { Link } from '@tanstack/react-router'
import { useTasks } from '@/db/hooks'
import { isTemplate, taskKind, type TaskResource } from '@/kinds/task'
import { todayLocal, fmtDateInPhrase, fmtMinutes } from '@/lib/time'
import { Button, Empty, PageTitle } from '@/components/ui'
import { AppTabs, AHEAD_TABS } from '@/components/AppTabs'

export const RecurringView = () => {
  const templates = (useTasks() ?? [])
    .filter((t) => isTemplate(t.spec))
    .sort((a, b) => (a.status.next_due ?? '').localeCompare(b.status.next_due ?? ''))
  const [adding, setAdding] = useState(false)
  const today = todayLocal()
  const Form = taskKind.Form
  const row = (t: TaskResource) => (
    <li key={t.id}>
      <Link to="/tasks/$id" params={{ id: t.id }} className="block px-3.5 py-2.5 min-h-12">
        <div className={t.status.state === 'done' ? 'text-faint line-through' : ''}>{t.spec.title}</div>
        <div className="text-xs text-muted flex gap-3 flex-wrap mt-0.5">
          <span>{describeRule(t.spec.recurrence)}</span>
          {t.status.next_due && <span>next copy {fmtDateInPhrase(t.status.next_due, today)}</span>}
          {t.spec.nag_minutes ? <span>nags every {fmtMinutes(t.spec.nag_minutes)}</span> : null}
          {t.status.state === 'done' && <span>Finished</span>}
        </div>
      </Link>
    </li>
  )
  return (
    <div>
      <PageTitle right={<Button onClick={() => setAdding(true)}>New recurring task</Button>}>
        Review
      </PageTitle>
      <AppTabs tabs={AHEAD_TABS} label="Calendar" />
      {templates.length === 0 ? (
        <Empty>No recurring tasks. Each one keeps a single open copy; missed days never pile up.</Empty>
      ) : (
        <ul className="group-list">{templates.map(row)}</ul>
      )}
      {adding && <Form onDone={() => setAdding(false)} resource={undefined} />}
    </div>
  )
}
